$(document).ready(function() {
    section2();
    section3();
    section4();
});

$(window).scroll(function() {
    section2();
    section3();
    section4();
});

function section2() {
    $section2 = $('#contact-section-2');
    if (wSize >= 1280) {
        if (visiblePercent($section2) > 40) {
            if (!$section2.find('.aos-init').hasClass('aos-animate')) {
                $section2.find('.aos-init').addClass('aos-animate');
            }
        }
        else {
            if ($section2.find('.aos-init').hasClass('aos-animate')) {
                $section2.find('.aos-init').removeClass('aos-animate');
            }
        }
    }
    else {
        if (visiblePercent($section2) > 10) {
            if (!$section2.find('.aos-init').hasClass('aos-animate')) {
                $section2.find('.aos-init').addClass('aos-animate');
            }
        }
        else {
            if ($section2.find('.aos-init').hasClass('aos-animate')) {
                $section2.find('.aos-init').removeClass('aos-animate');
            }
        }
    }
}

function section3() {
    $section3 = $('#contact-section-3');
    if (visiblePercent($section3) > 40) {
        if (!$section3.find('.aos-init').hasClass('aos-animate')) {
            $section3.find('.aos-init').addClass('aos-animate');
        }
    }
    else {
        if ($section3.find('.aos-init').hasClass('aos-animate')) {
            $section3.find('.aos-init').removeClass('aos-animate');
        }
    }
}

function section4() {
    $section4 = $('#contact-section-4');
    if (visiblePercent($section4) > 40) {
        if (!$section4.find('.aos-init').hasClass('aos-animate')) {
            $section4.find('.aos-init').addClass('aos-animate');
        }
    }
    else {
        if ($section4.find('.aos-init').hasClass('aos-animate')) {
            $section4.find('.aos-init').removeClass('aos-animate');
        }
    }
}